import React from 'react';
import Button from "./Button";

const PricingBtn = (props) => {

	return (
		<div className="row centered form-row button-row">
			<div className="col-xs-12">
				<Button
					action={event => props.handleSubmit(event)}
					image="/images/btn-view-prices.svg"
					alt="View Prices"
					newClass="fibre-submit-btn"
				/>
				{props.children}
			</div>
		</div>
	);

};

export default PricingBtn;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/PricingBtn.js